import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '@stromo/shared';

interface AuthState {
  token: string | null;
  user: User | null;
  setAuth: (token: string, user: User) => void;
  setUser: (user: User) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setAuth: (token, user) => set({ token, user }),
      setUser: (user) => set({ user }),
      clear: () => set({ token: null, user: null }),
    }),
    {
      name: 'stromo-auth',
      // Token im localStorage — überlebt App-Schliessen und Neustart.
      // Auf iOS-PWA war vorher sessionStorage aktiv, dort wird jeder
      // App-Kill zur Neu-Anmeldung gezwungen. Sicherheit wird durch
      // die JWT-Expiry (default 30d) abgegrenzt; bei 401 redirected
      // der API-Interceptor automatisch zum Login.
      storage: {
        getItem: (name) => {
          const value = localStorage.getItem(name);
          return value ? JSON.parse(value) : null;
        },
        setItem: (name, value) => localStorage.setItem(name, JSON.stringify(value)),
        removeItem: (name) => localStorage.removeItem(name),
      },
    },
  ),
);
